// extracted by mini-css-extract-plugin
export default {"documentForm":"Documents_documentForm__TAQSx"};